export default "/27396006fbc5445db7e473f660063e72.svg";